import React from 'react'
import {
  companyLogoMaxHeight,
  companyLogoMaxWidth,
  mq,
  SMARTQUOTE_CLOSE,
  SMARTQUOTE_OPEN,
} from '../../utils'
import { Text } from '../Text'
import { IProps } from './index'

export const FeatureTestimonial = (props: IProps) => {
  const { quote, name, jobTitle, companyName, companyLogo } = props
  const parsedName = `${name}, `
  return (
    <div className="feature-spotlight__testimonial">
      <blockquote className="feature-spotlight__quote-text">
        <Text size="body" brand="default">
          {SMARTQUOTE_OPEN}
          {quote}
          {SMARTQUOTE_CLOSE}
        </Text>
      </blockquote>
      <cite className="feature-spotlight__quote-source">
        <Text size="caption-bold" brand="default">
          {parsedName}
        </Text>
        <Text size="caption" brand="default">
          {jobTitle}
        </Text>
      </cite>
      {companyLogo && (
        <img className="feature-spotlight__company-logo" src={companyLogo} alt={companyName} />
      )}
      <style jsx>
        {`
          .feature-spotlight__testimonial {
            text-align: center;
            padding: 0 1rem;
          }

          .feature-spotlight__quote-text + .feature-spotlight__quote-source {
            margin-top: 0.625rem;
          }

          .feature-spotlight__quote-source {
            display: block;
            font-style: normal;
          }

          .feature-spotlight__quote-source + .feature-spotlight__company-logo {
            margin-top: 0.625rem;
          }

          .feature-spotlight__company-logo {
            display: inline-block;
            /* only limit height to allow for wide logos with wordmarks */
            max-height: ${companyLogoMaxHeight};
            max-width: ${companyLogoMaxWidth};
          }

          @media (${mq.tablet}) {
            .feature-spotlight__testimonial {
              text-align: left;
              padding: 1.75rem 0 0;
              border-top: 1px solid black;
            }

            .feature-spotlight__quote-text {
              text-indent: -5px;
            }
          }

          @media (${mq.desktop}) {
            .feature-spotlight__testimonial {
              max-width: 80%;
              border-top: 1px solid black;
            }
          }
        `}
      </style>
    </div>
  )
}
